<template>
  <div class="news_cont_zong" v-loading="loading">
    <div class="news-list">
      <div
        class="news-card"
        v-for="(item, index) in newsList"
        :key="index"
        @click="funUrl(item.id)"
      >
        <div class="news-card-image">
          <img
            :src="getImageUrl(item)"
            @error="handleImageError(item)"
            alt=""
          />
        </div>
        <div class="news-card-content">
          <div class="news-card-body">
            <h2 class="news-card-title">{{ item.title }}</h2>
            <p class="news-card-desc">{{ item.author || "" }}</p>
          </div>
          <div class="news-card-footer">
            <span class="news-card-date">{{ item.publishDate }}</span>
            <span class="news-card-more"
              >阅读全文 <i class="el-icon-arrow-right"></i
            ></span>
          </div>
        </div>
      </div>
    </div>

    <div class="pagination-wrapper" v-if="pagination.total > 0">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pagination.current"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="pagination.size"
        layout="total, prev, pager, next"
        :total="pagination.total"
      >
      </el-pagination>
    </div>

    <div v-if="!loading && newsList.length === 0" class="empty-state">
      <i class="el-icon-document-delete"></i>
      <p>暂无相关资讯</p>
    </div>
  </div>
</template>

<script>
import article from "@/api/article";
export default {
  name: "MediaCoverage",
  data() {
    return {
      defaultImage:
        "https://minio.gxbcxx.com/baochenhome/upload/20260306/49f3a6feae87249631b8ba0bdbe312f2.jpg",
      newsList: [],
      pagination: {
        total: 0,
        size: 10,
        current: 1,
      },
      loading: false,
    };
  },

  mounted() {
    this.getList();
  },
  methods: {
    funUrl(id) {
      this.$router.push({
        path: "/newsdetal",
        query: { id },
      });
    },
    getList() {
      this.loading = true;
      let params = {
        size: this.pagination.size,
        current: this.pagination.current,
        newType: 1,
        categoryNames: "政策法规",
      };
      article
        .getList(params)
        .then((res) => {
          let result = res.data.data;
          this.pagination.total = result.total;
          this.pagination.size = result.size;
          this.pagination.current = result.current;
          this.newsList = result.records.map((item) => ({
            ...item,
            imageFailed: false,
          }));
          this.loading = false;
        })
        .catch((error) => {
          console.error(error);
          this.loading = false;
        });
    },
    handleImageError(item) {
      item.imageFailed = true;
    },
    getImageUrl(item) {
      if (item.imageFailed) return this.defaultImage;
      if (!item.cover || item.cover === "null" || item.cover === "undefined")
        return this.defaultImage;
      // 过滤特定的演示站占位图
      if (
        item.cover ===
        "https://demo-open-doc.oss-cn-hangzhou.aliyuncs.com/1110WZ/site_group/dev/site_02020/09/09/f9a168d2-7d99-4267-8618-f46041ebdb3b.jpg"
      ) {
        return this.defaultImage;
      }
      return item.cover;
    },
    handleSizeChange(val) {
      this.pagination.size = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.pagination.current = val;
      this.getList();
    },
  },
};
</script>

<style lang="less" scoped>
.news_cont_zong {
  width: 100%;
}

.news-list {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.news-card {
  display: flex;
  background: #ffffff;
  border-radius: 12px;
  overflow: hidden;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  cursor: pointer;
  border: 1px solid transparent;

  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 12px 24px -8px rgba(0, 0, 0, 0.15);
    border-color: #e2e8f0;

    .news-card-title {
      color: #3494ec;
    }

    .news-card-image img {
      transform: scale(1.05);
    }

    .news-card-more {
      color: #3494ec;
      transform: translateX(4px);
    }
  }
}

.news-card-image {
  width: 320px;
  height: 200px;
  overflow: hidden;
  flex-shrink: 0;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.5s ease;
  }
}

.news-card-content {
  flex: 1;
  padding: 24px 32px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.news-card-title {
  font-size: 20px;
  font-weight: 600;
  color: #1e293b;
  line-height: 1.4;
  margin-bottom: 12px;
  transition: color 0.3s;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.news-card-desc {
  font-size: 14px;
  color: #64748b;
  line-height: 1.6;
  margin-bottom: 16px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.news-card-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 16px;
  border-top: 1px solid #f1f5f9;
}

.news-card-date {
  font-size: 14px;
  color: #94a3b8;
}

.news-card-more {
  font-size: 14px;
  font-weight: 500;
  color: #64748b;
  transition: all 0.3s;
  display: flex;
  align-items: center;
  gap: 4px;
}

.pagination-wrapper {
  margin-top: 40px;
  display: flex;
  justify-content: center;
}

.empty-state {
  padding: 80px 0;
  text-align: center;
  color: #94a3b8;

  i {
    font-size: 48px;
    margin-bottom: 16px;
  }

  p {
    font-size: 16px;
  }
}
</style>
